import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__account",
  "use": "icon__account-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__account\"><path d=\"M15 16v-1a4 4 0 00-4-4H5a4 4 0 00-4 4v1\" stroke=\"#000\" stroke-width=\"1.2\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 7.8a2.8 2.8 0 100-5.6 2.8 2.8 0 000 5.6zM8 9a4 4 0 100-8 4 4 0 000 8zM.4 15A4.6 4.6 0 015 10.4h6a4.6 4.6 0 014.6 4.6v1h-1.2v-1a3.4 3.4 0 00-3.4-3.4H5A3.4 3.4 0 001.6 15v1H.4v-1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol